import { graphClient } from '../../graph-client'
import { GET_USERS_GIFTS_PACKAGES_BY_USER_ID } from './gql'
import type { Get } from './types'

class GiftPackageService {
  async get({ take, skip }: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_USERS_GIFTS_PACKAGES_BY_USER_ID,
      {
        take,
        skip: take * skip,
      },
    )

    return request?.getUsersGiftsPackagesByMyUserId
  }
}

export const giftPackageService = new GiftPackageService()
